(function(){
  function pad2(n){ return n < 10 ? '0' + n : '' + n; }

  function shipLine(root){
    var el = root.querySelector('[data-llo-ship]');
    if(!el) return;
    var out = el.querySelector('[data-llo-ship-text]');
    if(!out) return;

    var tpl = el.getAttribute('data-ship-template') || '{date}';
    var skip = el.getAttribute('data-ship-skip-weekend') === 'true';
    var loc = root.dataset.locale || 'fr';

    var d = new Date();
    d.setDate(d.getDate() + 1);
    if(skip){
      // 6 = zaterdag, 0 = zondag -> doorschuiven naar maandag
      while(d.getDay() === 6 || d.getDay() === 0){ d.setDate(d.getDate() + 1); }
    }

    var longDay, shortDay;
    try {
      longDay = d.toLocaleDateString(loc, { weekday: 'long' });
      shortDay = d.toLocaleDateString(loc, { weekday: 'short' });
    } catch(e) {
      longDay = d.toLocaleDateString('fr', { weekday: 'long' });
      shortDay = d.toLocaleDateString('fr', { weekday: 'short' });
    }

    // "mar." -> "Mar"
    shortDay = String(shortDay).replace(/\.+$/, '');
    shortDay = shortDay.charAt(0).toUpperCase() + shortDay.slice(1);

    // "Mar 01-09-2026"
    var full = shortDay + ' ' + pad2(d.getDate()) + '-' + pad2(d.getMonth() + 1) + '-' + d.getFullYear();

    function esc(s){
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    var html = esc(tpl)
      .replace(/\{date\}/g, '<span class="llo__shipDay">' + esc(full) + '</span>')
      .replace(/\{jour\}/g, '<span class="llo__shipDay">' + esc(longDay) + '</span>');

    out.innerHTML = html;
  }

  function init(root){
    if(root.dataset.lloReady === '1') return;
    root.dataset.lloReady = '1';

    var variantInput = root.querySelector('[data-llo-variant]');
    var qtyInput = root.querySelector('[data-llo-qty]');
    var planInput = root.querySelector('[data-llo-plan]');

    shipLine(root);

    root.querySelectorAll('[data-llo-offer]').forEach(function(offer){
      var radio = offer.querySelector('.llo__radio');
      if(!radio) return;
      radio.addEventListener('change', function(){
        root.querySelectorAll('[data-llo-offer]').forEach(function(o){ o.classList.remove('is-selected'); });
        offer.classList.add('is-selected');
        if(variantInput && radio.value) variantInput.value = radio.value;
        if(qtyInput) qtyInput.value = radio.dataset.qty || 1;
      });
    });

    var sub = root.querySelector('[data-llo-sub]');
    if(sub && planInput){
      var apply = function(){
        if(sub.checked && sub.value){ planInput.value = sub.value; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      };
      sub.addEventListener('change', apply);
      apply();
    }

    var main = root.querySelector('.llo__heroImg');
    var strip = root.querySelector('.llo__thumbs');

    if(strip){
      var originals = Array.prototype.slice.call(strip.querySelectorAll('[data-llo-thumb]'));
      var count = originals.length;

      if(count > 1){
        originals.forEach(function(o){
          var c = o.cloneNode(true);
          c.classList.remove('is-active');
          c.setAttribute('data-llo-clone', '');
          strip.appendChild(c);
        });
      }

      var all = Array.prototype.slice.call(strip.querySelectorAll('[data-llo-thumb]'));
      var settle = null;

      function halfWidth(){ return strip.scrollWidth / 2; }

      function normalize(){
        if(count < 2) return;
        var half = halfWidth();
        if(half <= 0) return;
        if(strip.scrollLeft >= half - 1){
          strip.style.scrollBehavior = 'auto';
          strip.scrollLeft = strip.scrollLeft - half;
          strip.style.scrollBehavior = '';
        }
      }

      strip.addEventListener('scroll', function(){
        if(settle) clearTimeout(settle);
        settle = setTimeout(normalize, 160);
      });

      function slideTo(el){
        var target = el.offsetLeft - strip.offsetLeft;
        if(target < 0) target = 0;
        if(typeof strip.scrollTo === 'function'){
          strip.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          strip.scrollLeft = target;
        }
      }

      all.forEach(function(t, domIndex){
        var logical = count > 0 ? domIndex % count : 0;
        t.addEventListener('click', function(){
          if(main && t.dataset.src){
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.removeAttribute('width');
            main.removeAttribute('height');
            main.src = t.dataset.src;
            if(t.dataset.alt) main.alt = t.dataset.alt;
          }
          all.forEach(function(x, xi){
            if(count > 0 && xi % count === logical) x.classList.add('is-active');
            else x.classList.remove('is-active');
          });
          slideTo(t);
        });
      });
    }

    var del = root.querySelector('[data-llo-delivery]');
    if(del){
      var days = parseInt(root.dataset.days || '3', 10);
      var dloc = root.dataset.locale || 'nl-NL';
      var dd = new Date();
      dd.setDate(dd.getDate() + days);
      var str = dd.toLocaleDateString(dloc, { weekday: 'long', day: 'numeric', month: 'long' });
      del.innerHTML = (root.dataset.deliveryTemplate || '{date}').replace('{date}', '<u>' + str + '</u>');
    }

    function close(m){ m.hidden = true; document.body.style.overflow = ''; }

    root.querySelectorAll('[data-llo-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var m = root.querySelector('[data-llo-modal="' + btn.dataset.lloOpen + '"]');
        if(!m) return;
        m.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    root.querySelectorAll('[data-llo-modal]').forEach(function(m){
      m.querySelectorAll('[data-llo-close]').forEach(function(b){
        b.addEventListener('click', function(){ close(m); });
      });
    });

    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      root.querySelectorAll('[data-llo-modal]').forEach(function(m){ if(!m.hidden) close(m); });
    });
  }

  /* ---------------------------------------------------------------
     Bridge between the size picker and bundle apps such as Katching.
     Fires whenever our variant picker selects a different variant.
  ---------------------------------------------------------------- */
  function bridge(variant){
    if(!variant || !variant.id) return;
    var id = String(variant.id);

    document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function(el){
      if(el.value === id) return;
      if(el.tagName === 'SELECT'){
        var has = false;
        for(var o = 0; o < el.options.length; o++){
          if(el.options[o].value === id){ has = true; break; }
        }
        if(!has) return;
      }
      el.value = id;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var names = ['variant:changed', 'variantChange', 'variant_change', 'product:variant-change', 'katching:variant-change'];
    for(var n = 0; n < names.length; n++){
      document.dispatchEvent(new CustomEvent(names[n], { bubbles: true, detail: { variant: variant, id: variant.id } }));
    }

    if(window.Shopify){
      window.Shopify.selectedVariantId = variant.id;
      if(typeof window.Shopify.setSelectedVariant === 'function'){
        try { window.Shopify.setSelectedVariant(variant.id); } catch(e) {}
      }
    }

    if(window.Katching && typeof window.Katching.refresh === 'function'){
      try { window.Katching.refresh(variant.id); } catch(e) {}
    }
  }

  document.addEventListener('variant:change', function(e){
    if(e && e.detail && e.detail.variant) bridge(e.detail.variant);
  });

  function boot(){ document.querySelectorAll('[data-llo]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){
    var t = e && e.target ? e.target.querySelector('[data-llo]') : null;
    if(t) t.dataset.lloReady = '';
    boot();
  });
})();
